var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcClock = function SvgIcClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 8.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm1.5 0a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0ZM9.25 5.286a.75.75 0 0 0-1.5 0v3.06c0 .19.072.374.202.513l2.143 2.296a.75.75 0 1 0 1.096-1.024L9.25 8.051V5.286Z"
  })));
};
export default SvgIcClock;